var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanySize1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 25,
    viewBox: "0 0 64 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "company_size_1_clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2628",
    "data-name": "Rectangle 2628",
    width: 64,
    height: 25,
    transform: "translate(-0.036 -0.221)",
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3331",
    "data-name": "Group 3331",
    transform: "translate(0.036 0.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1574",
    "data-name": "Mask Group 1574",
    transform: "translate(0 0)",
    clipPath: "url(#company_size_1_clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "M63.306,307H.867a.867.867,0,0,0,0,1.734H63.306a.867.867,0,0,0,0-1.734",
    transform: "translate(-0.165 -284.692)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M556.791,4.642a.828.828,0,0,1-.828-.828V.828a.828.828,0,0,1,1.656,0V3.814a.828.828,0,0,1-.828.828",
    transform: "translate(-515.951 0.122)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    d: "M327.45,4.642a.828.828,0,0,1-.828-.828V.828a.828.828,0,0,1,1.656,0V3.814a.828.828,0,0,1-.828.828",
    transform: "translate(-303.183 0.122)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    d: "M556.791,61.915a.828.828,0,0,1-.828-.828V42.149a.828.828,0,0,1,1.656,0V61.087a.828.828,0,0,1-.828.828",
    transform: "translate(-515.951 -38.213)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    d: "M183.171,65.951H165.333a.829.829,0,0,1-.584-1.416c.092-.09,9.135-9.144,11.33-18.231a.83.83,0,0,1,.805-.633H193.7a.829.829,0,0,1,.822.721A34.079,34.079,0,0,0,204.8,64.517a.829.829,0,0,1-.564,1.434h-21.06Zm2.022-1.656H202.21A36.365,36.365,0,0,1,193.7,50,36.4,36.4,0,0,1,185.193,64.3m-17.936,0h15.586A34.748,34.748,0,0,0,192.7,47.327h-15.17c-1.973,7.228-7.651,14.085-10.269,16.968",
    transform: "translate(-152.782 -42.248)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M380.881,261.659a.824.824,0,0,1-.671-.344l-2.437-3.379a.828.828,0,0,1,1.342-.968l2.437,3.379a.827.827,0,0,1-.671,1.312",
    transform: "translate(-350.492 -237.957)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M134.06,261.661a.824.824,0,0,1-.671-.344l-2.435-3.379a.827.827,0,1,1,1.342-.968l2.435,3.379a.828.828,0,0,1-.671,1.312",
    transform: "translate(-121.509 -237.958)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    d: "M701.412,261.661a.828.828,0,0,1-.671-1.312l2.435-3.379a.827.827,0,1,1,1.342.968l-2.436,3.379a.824.824,0,0,1-.671.344",
    transform: "translate(-650.12 -237.958)",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanySize1);
export default __webpack_public_path__ + "static/media/company_size_1.613ce4ab.svg";
export { ForwardRef as ReactComponent };